import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import { UserAuthContextProvider } from "./context/UserAuthContext";
import ForgotPassword from "./components/ForgotPassword";
import PersonalInformation from "./components/PersonalInformation";
import ChangePassword from "./components/ChangePassword";
import Categories from "./components/Categories";
import Products from "./components/Products";
import Units from "./components/Units";
import Users from "./components/Users";
import SalesHistory from "./components/SalesHistory";
import { DashboardProvider } from "./context/DashboardContext";
import { ManagementProvider } from "./context/ManagementContext";
import Salary from "./components/Salary";
import Payroll from "./components/Payroll";
import Departments from "./components/Departments";
import Ranks from "./components/Ranks";
import SalaryStructure from "./components/SalaryStructure";
import SalesEntry from "./components/SalesEntry";
import RoomTypes from "./components/RoomTypes";
import Rooms from "./components/Rooms";
import RatePlans from "./components/RatePlans";
import Amenities from "./components/Amenities";
import Expenditure from "./components/Expenditure";
import Guests from "./components/Guests";
import JournalEntries from "./components/JournalEnteries";
import GeneralLedger from "./components/GeneralLedger";
import Accounts from "./components/Accounts";
import CheckoutEntries from "./components/CheckoutEntries";
import AccountStatements from "./components/AccountStatements";
import Batches from "./components/Batches";
import HotelAccounts from "./components/HotelAccounts";

function App() {
  return (
    <>
      <UserAuthContextProvider>
        <DashboardProvider>
          <ManagementProvider>
            <Routes>              
              <Route
                path="/home"
                element={<ProtectedRoute><Home /></ProtectedRoute>}
              />
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/personal-information" element={<ProtectedRoute><PersonalInformation /></ProtectedRoute>} />
              <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />

              <Route path="/categories" element={<ProtectedRoute><Categories/></ProtectedRoute>} />
              <Route path="/departments" element={<ProtectedRoute><Departments /></ProtectedRoute>} />
              <Route path="/ranks" element={<ProtectedRoute><Ranks /></ProtectedRoute>} />
              <Route path="/staff" element={<ProtectedRoute><Users/></ProtectedRoute>} />
              <Route path="/salary" element={<ProtectedRoute><Salary /></ProtectedRoute>} />
              <Route path="/salary-structure" element={<ProtectedRoute><SalaryStructure /></ProtectedRoute>} />
              <Route path="/payroll" element={<ProtectedRoute><Payroll /></ProtectedRoute>} />
            
              <Route path="/products" element={<ProtectedRoute><Products/></ProtectedRoute>} />
              <Route path="/units" element={<ProtectedRoute><Units/></ProtectedRoute>} />
              <Route path="/sales-history" element={<ProtectedRoute><SalesHistory /></ProtectedRoute>} />
              <Route path="/sales-entry" element={<ProtectedRoute><SalesEntry /></ProtectedRoute>} />
              <Route path="/expenditure" element={<ProtectedRoute><Expenditure /></ProtectedRoute>} />
              <Route path="/room-types" element={<ProtectedRoute><RoomTypes /></ProtectedRoute>} />
              <Route path="/rooms" element={<ProtectedRoute><Rooms /></ProtectedRoute>} />
              <Route path="/rate-plans" element={<ProtectedRoute><RatePlans /></ProtectedRoute>} />
              <Route path="/amenities" element={<ProtectedRoute><Amenities /></ProtectedRoute>} />           
              <Route path="/guests" element={<ProtectedRoute><Guests /></ProtectedRoute>} />    

              <Route path="/accounts" element={<ProtectedRoute><Accounts /></ProtectedRoute>} />
              <Route path="/hotel-accounts" element={<ProtectedRoute><HotelAccounts /></ProtectedRoute>} />
              <Route path="/batches" element={<ProtectedRoute><Batches /></ProtectedRoute>} />
              <Route path="/checkout-entries" element={<ProtectedRoute><CheckoutEntries /></ProtectedRoute>} />
              <Route path="/account-statements" element={<ProtectedRoute><AccountStatements /></ProtectedRoute>} />       
              <Route path="/journal-entries" element={<ProtectedRoute><JournalEntries /></ProtectedRoute>} />
              <Route path="/general-ledger" element={<ProtectedRoute><GeneralLedger /></ProtectedRoute>} />       
            </Routes>
          </ManagementProvider>
        </DashboardProvider>
      </UserAuthContextProvider>
    </>
  );
}

export default App;